/* istanbul ignore file */ // Callback function expected to be tested again, will be fixed in a separate PR
import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeft16Regular } from '@fluentui/react-icons';
import {
  Button,
  Caption1Strong,
  Divider,
  mergeClasses,
} from '@fluentui/react-components';
import {
  FontsFamilySelector,
  FontsWeightSelector,
} from '@bingads-webui-campaign-react/fonts-selector';

import { ColorPicker } from '../color-picker';
import { useTextFormattingDialogueStyles } from './styles';

const overrideFontWeights = [
  { key: 'Normal', text: _TL_('Normal') },
  { key: 'Bold', text: _TL_('Bold') },
];

export const TextFormattingDialogue = ({
  i18n,
  onToggleBack,
  onFormatText,
  isUsedForButton,
  textFormatOptions,
  hideColorFormatting,
}) => {
  const {
    font,
    color,
    weight,
    // backgroundColor,
  } = textFormatOptions || {};
  const classes = useTextFormattingDialogueStyles();

  const onChangeFont = (value) => {
    onFormatText({ ...textFormatOptions, font: value });
  };

  const onChangeWeight = (value) => {
    onFormatText({ ...textFormatOptions, weight: value });
  };

  const onChangeColor = (value) => {
    onFormatText({ ...textFormatOptions, color: value });
  };

  // TODO: Uncomment this when the feature is ready
  // const onChangeButtonColor = (value) => {
  //   onFormatText({ ...textFormatOptions, backgroundColor: value });
  // };

  return (
    <div
      className={mergeClasses(
        'display-ads-text-formatting-dialogue',
        classes.containerWrapper
      )}
    >
      <div className={classes.container}>
        <div
          className={mergeClasses(
            'text-formatting-dialogue-header',
            classes.header
          )}
        >
          <Button
            appearance="transparent"
            icon={<ArrowLeft16Regular />}
            onClick={onToggleBack}
          >
            {i18n.getString(_TL_('Back'))}
          </Button>
        </div>
        <Divider appearance="strong" />
        <div
          className={mergeClasses(
            'text-formatting-dialogue-content',
            classes.content
          )}
        >
          <Caption1Strong className={classes.fontSelectorHeader}>{i18n.getString(_TL_('Styles'))}</Caption1Strong>
          <div className={classes.fontContainer}>
            <FontsFamilySelector
              i18n={i18n}
              value={font}
              onChange={onChangeFont}
              selectClassName={classes.fontSelect}
            />
            <FontsWeightSelector
              i18n={i18n}
              value={weight}
              onChange={onChangeWeight}
              overrideFontWeights={overrideFontWeights}
              selectClassName={classes.fontWeightSelect}
            />
          </div>
          {!hideColorFormatting && (
            <>
              <Divider appearance="strong" className={classes.contentDivider} />
              <ColorPicker
                i18n={i18n}
                color={color}
                onChangeColor={onChangeColor}
                label={i18n.getString(isUsedForButton ? _TL_('Button color') : _TL_('Text color'))}
              />
              {/* TODO: Uncomment thi when feature is ready */}
              {/* {isUsedForButton && (
                <ColorPicker
                  i18n={i18n}
                  color={backgroundColor}
                  onChangeColor={onChangeButtonColor}
                  label={i18n.getString(_TL_('Button color'))}
                />
              )} */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

TextFormattingDialogue.propTypes = {
  i18n: PropTypes.shape({ getString: PropTypes.func }).isRequired,
  onToggleBack: PropTypes.func.isRequired,
  isUsedForButton: PropTypes.bool,
  hideColorFormatting: PropTypes.bool,
  textFormatOptions: PropTypes.shape({
    font: PropTypes.string,
    color: PropTypes.string,
    weight: PropTypes.string,
  })
    .isRequired,
  onFormatText: PropTypes.func.isRequired,
};

TextFormattingDialogue.defaultProps = {
  isUsedForButton: false,
  hideColorFormatting: false,
};
